import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "bmp_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);

export const fetchMe = () => axios.get(`${API}/auth/me`, { headers: authHeader() }).then((r) => r.data);
export const fetchStats = () => axios.get(`${API}/admin/stats`, { headers: authHeader() }).then((r) => r.data);
export const fetchLeads = () => axios.get(`${API}/leads`, { headers: authHeader() }).then((r) => r.data);
export const fetchCallBookings = () => axios.get(`${API}/call-bookings`, { headers: authHeader() }).then((r) => r.data);

// CMS reads (public endpoints, no auth needed)
export const fetchSettings = () => axios.get(`${API}/content/settings`).then((r) => r.data);
export const fetchTestimonials = () => axios.get(`${API}/content/testimonials`).then((r) => r.data);
export const fetchThemes = () => axios.get(`${API}/content/event-themes`).then((r) => r.data);

// CMS writes (auth)
export const saveSettings = (data) => axios.put(`${API}/content/settings`, data, { headers: authHeader() }).then((r) => r.data);
export const createTestimonial = (data) => axios.post(`${API}/content/testimonials`, data, { headers: authHeader() }).then((r) => r.data);
export const updateTestimonial = (id, data) => axios.put(`${API}/content/testimonials/${id}`, data, { headers: authHeader() }).then((r) => r.data);
export const deleteTestimonial = (id) => axios.delete(`${API}/content/testimonials/${id}`, { headers: authHeader() }).then((r) => r.data);
export const createTheme = (data) => axios.post(`${API}/content/event-themes`, data, { headers: authHeader() }).then((r) => r.data);
export const updateTheme = (id, data) => axios.put(`${API}/content/event-themes/${id}`, data, { headers: authHeader() }).then((r) => r.data);
export const deleteTheme = (id) => axios.delete(`${API}/content/event-themes/${id}`, { headers: authHeader() }).then((r) => r.data);

export const fetchPress = () => axios.get(`${API}/content/press`).then((r) => r.data);
export const createPress = (data) => axios.post(`${API}/content/press`, data, { headers: authHeader() }).then((r) => r.data);
export const updatePress = (id, data) => axios.put(`${API}/content/press/${id}`, data, { headers: authHeader() }).then((r) => r.data);
export const deletePress = (id) => axios.delete(`${API}/content/press/${id}`, { headers: authHeader() }).then((r) => r.data);
